import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const CARD_COUNT = 6;

const MarketplaceCardSkeleton: React.FC = () => (
  <View style={styles.gridItem}>
    <SkeletonCard padding={0} borderRadius={12}>
      {/* Listing image */}
      <SkeletonBone width="100%" height={120} borderRadius={0} />
      <View style={styles.cardBody}>
        <SkeletonBone width="70%" height={14} />
        <SkeletonBone width={60} height={18} />
        <SkeletonBone width={80} height={12} />
      </View>
    </SkeletonCard>
  </View>
);

export const MarketplaceSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Search bar placeholder */}
    <SkeletonBone width="100%" height={40} borderRadius={20} />

    {/* Category chips */}
    <View style={styles.chipRow}>
      <SkeletonBone width={70} height={28} borderRadius={14} />
      <SkeletonBone width={85} height={28} borderRadius={14} />
      <SkeletonBone width={65} height={28} borderRadius={14} />
      <SkeletonBone width={75} height={28} borderRadius={14} />
    </View>

    {/* Grid of cards */}
    <View style={styles.grid}>
      {Array.from({ length: CARD_COUNT }).map((_, i) => (
        <MarketplaceCardSkeleton key={i} />
      ))}
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
  },
  chipRow: {
    flexDirection: 'row',
    gap: 8,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
  },
  gridItem: {
    width: '48%',
  },
  cardBody: {
    padding: 10,
    gap: 6,
  },
});
